"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ObjectTypes = _interopRequireDefault(require("customer-data-objects/constants/ObjectTypes"));

var _ObjectTypes$CONTACT$;

var _default = (_ObjectTypes$CONTACT$ = {}, (0, _defineProperty2.default)(_ObjectTypes$CONTACT$, _ObjectTypes.default.CONTACT, '0-1'), (0, _defineProperty2.default)(_ObjectTypes$CONTACT$, _ObjectTypes.default.COMPANY, '0-2'), (0, _defineProperty2.default)(_ObjectTypes$CONTACT$, _ObjectTypes.default.DEAL, '0-3'), (0, _defineProperty2.default)(_ObjectTypes$CONTACT$, _ObjectTypes.default.TICKET, '0-5'), _ObjectTypes$CONTACT$);

exports.default = _default;
module.exports = exports.default;